import React, { Fragment } from "react";

import NoAssignee from "@common/assets/images/unassigned-icon.png";
import { BrowserNameIcon } from "@common/components/DetailsPane/icons";
import RoundedCanvas from "@common/components/RoundedCanvas/RoundedCanvas";
import displayToast from "@common/components/Toast/displayToast";
import Tooltip from "@common/components/Tooltip/Tooltip";
import environments from "@common/environments";
import { Issue } from "@common/models/issueTracking";
import { Flex } from "@common/styles/reusable/Flex/Flex.styles";
import identifiers from "@common/util/identifiers.json";
import * as Icon from "@public/pages/shared/icons/icons";

import * as Styled from "./DetailsBar.styles";

interface DetailsBarProps {
  details: Issue;
}

export const DetailsBar = ({ details }: DetailsBarProps) => {
  const handleCopyClick = () => {
    if (!("public_url" in details) || !details.public_url) return;
    navigator.clipboard.writeText(details.public_url);
    displayToast({
      content: "External URL copied to clipboard",
    });
  };

  return (
    <>
      <Styled.TicketDetailsBar>
        <Flex
          $gap={1}
          $alignItems="center"
        >
          <Tooltip
            text={"Unassigned"}
            position="top"
          >
            <Styled.AssigneeDropdown
              wide
              buttonElement={
                <RoundedCanvas
                  letter={undefined}
                  image={NoAssignee}
                />
              }
              position="left"
              isOpened={false}
              setIsOpened={() => 0}
              testId={identifiers["central.column.assignee.icon"]}
              disabled={true}
            ></Styled.AssigneeDropdown>
          </Tooltip>

          <Tooltip
            position="top"
            text="Set status"
          >
            <Styled.StatusPriorityDropdown
              label={"Open"}
              iconComponent={
                <Styled.IconContainer>
                  <Icon.StatusNewIcon />
                </Styled.IconContainer>
              }
              buttonElement={<Fragment />}
              position="left"
              isOpened={false}
              disabled={true}
              testId={identifiers["central.column.status.icon"]}
            ></Styled.StatusPriorityDropdown>
          </Tooltip>

          <Tooltip
            position="top"
            text="Set priority"
          >
            <Styled.StatusPriorityDropdown
              label={"Medium"}
              iconComponent={
                <Styled.IconContainer>
                  <Icon.PriorityMediumIcon />
                </Styled.IconContainer>
              }
              buttonElement={<Fragment />}
              position="left"
              isOpened={false}
              setIsOpened={() => 0}
              testId={identifiers["central.column.priority.button"]}
              disabled={true}
            ></Styled.StatusPriorityDropdown>
          </Tooltip>

          <Styled.DeleteMergeContainer>
            <Tooltip
              text={"Mark as duplicate of ..."}
              position="top"
              style={{ display: "flex", alignItems: "center" }}
            >
              <Styled.DuplicateContainer>
                <Icon.DuplicateIcon />
              </Styled.DuplicateContainer>
            </Tooltip>

            <Tooltip
              text="Delete ticket"
              position="top"
              style={{ display: "flex", alignItems: "center", width: "100%", justifyContent: "center" }}
            >
              <Styled.DeleteContainer>
                <Icon.DeleteIcon
                  width={20}
                  height={20}
                  style={{ margin: "0.8rem" }}
                />
              </Styled.DeleteContainer>
            </Tooltip>
          </Styled.DeleteMergeContainer>

          {"public_url" in details && (
            <Styled.ShareTicketContainer>
              {details.public_url && (
                <Styled.CopyContainer onClick={handleCopyClick}>
                  <BrowserNameIcon />
                  <Styled.ShareTicketText>{`${environments.shareDomain}/${details.public_key}`}</Styled.ShareTicketText>
                </Styled.CopyContainer>
              )}
            </Styled.ShareTicketContainer>
          )}
        </Flex>
      </Styled.TicketDetailsBar>
    </>
  );
};
